import { ArrowLeft, Lock } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * Lo que ve el empleado de un negocio suspendido cuando una pantalla no se le
 * abre (trd-client#269). Reemplaza a "No autorizado" y a "Módulo no incluido
 * en tu plan": con el negocio suspendido la negación viene de la suspensión
 * —con el flag de octopus apagado, hasta las lecturas—, y "Ver planes" lo
 * mandaba a una pantalla que sólo usa el dueño.
 */
export default function NegocioSuspendido() {
  const navigate = useNavigate();

  return (
    <section
      className="m-auto flex max-w-xl flex-col gap-4 p-6"
      aria-labelledby="negocio-en-modo-lectura"
    >
      <h1
        id="negocio-en-modo-lectura"
        className="flex items-center gap-2 text-2xl font-semibold text-balance"
      >
        <Lock className="icon text-text-secondary" />
        Tu negocio está en modo lectura
      </h1>
      <p className="text-text-secondary text-pretty">
        Hay un pago pendiente de la suscripción. Mientras tanto podés consultar
        la información, pero no hacer cambios. Hablá con el administrador del
        negocio.
      </p>
      <Button
        className="min-h-10 self-start"
        variant="outline"
        onClick={() => navigate("/")}
      >
        <ArrowLeft className="icon" />
        Volver al inicio
      </Button>
    </section>
  );
}
